export default {
  namespaced: true,
  state () {
    return {
      register: null
    }
  },
  getters: {
    register (state) {
      return state.register
    }
  },
  mutations: {
    register (state, payload) {
      state.register = payload
    }
  },
  actions: {
    register ({commit}, payload) {
      commit('register', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Register.js